import React from "react";
import {
  RouterProvider,
  createBrowserRouter,
  Navigate,
} from "react-router-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import Layout from "./components/Layout";
import Error from "./components/Error";
import Welcome from "./components/Landing";
import Predict from "./components/Predict/Predict";
import Admin from "./components/Admin/Admin";
import Database from "./components/Database/Database";
import HomePage from "./components/Home";
import Dashboard from "./components/Dashboard";
import TermsOfUse from "./components/About/TermsOfUse";
import ContactUs from "./components/About/ContactUs";
import NewsUpdatesPage from "./components/About/NewsUpdates";
import PublishNewsUpdates from "./components/About/PublishNewsUpdates";
import AdminRoute from "./AdminRoute";
import SignIn from "./components/Auth2.0/SignIn";
import SignUp from "./components/Auth2.0/SignUp";
import ResetPassword from "./components/Auth2.0/ResetPassword";
import AuthCallbackWithGoogle from "./components/Auth2.0/AuthCallback";
import EmailVerification from "./components/Auth2.0/EmailVerification";
import Profile from "./components/Account/Profile";
import Composition from "./components/Database/Composition";

const getDashboardComponent = () => {
  return process.env.REACT_APP_NAME === "COD'HEM" ? (
    <Dashboard />
  ) : (
    <HomePage />
  );
};

const queryClient = new QueryClient();

const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    errorElement: <Error />,
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      { path: "/dashboard", element: getDashboardComponent() },
      {
        path: "/home",
        element: <Welcome />,
      },
      {
        path: "/predict",
        element: <Predict />,
      },
      {
        path: "/database",
        element: <Database />,
      },
      {
        path: "/compositions/:id",
        element: <Composition />,
      },
      {
        path: "/account/profile",
        element: <Profile />,
      },
      {
        path: "/about/news-updates",
        element: <NewsUpdatesPage />,
      },
      { path: "/about/contact-us", element: <ContactUs /> },
      { path: "/about/terms", element: <TermsOfUse /> },
      {
        path: "/admin/news-updates/publish",
        element: <AdminRoute element={<PublishNewsUpdates />} />,
      },
    ],
  },
  {
    path: "/admin",
    element: <AdminRoute element={<Admin />} />,
  },
  {
    path: "/signin",
    element: <SignIn />,
    errorElement: <Error />,
  },
  {
    path: "/signin/oauth2/callback",
    element: <AuthCallbackWithGoogle />,
    errorElement: <Error />,
  },
  {
    path: "/signin/reset-password",
    element: <ResetPassword />,
    errorElement: <Error />,
  },
  {
    path: "/signup",
    element: <SignUp />,
    errorElement: <Error />,
  },
  {
    path: "/signup/verification",
    element: <EmailVerification />,
    errorElement: <Error />,
  },
]);

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}

export default App;
